import { useState, useRef, useEffect } from 'react'

export default ({
  continuous,
  onEnd,
  onError,
  onStart,
}) => {
  const recognizer = useRef()
  const [result, setResult] = useState('')
  const [isRecognizing, setIsRecognizing] = useState(false)

  useEffect(() => {
    window.SpeechRecognition = window.SpeechRecognition
      || window.webkitSpeechRecognition
      || window.mozSpeechRecognition
      || window.msSpeechRecognition
      || window.speechRecognition

    if (!window.SpeechRecognition) {
      return
    }

    recognizer.current = new window.SpeechRecognition()

    recognizer.current.continuous = continuous || false
    recognizer.current.interimResults = true

    recognizer.current.onend = onEnd
    recognizer.current.onerror = onError
    recognizer.current.onstart = onStart

    recognizer.current.onresult = (event) => {
      let finalResult = ''
      let interimResult = ''

      if (typeof event.results === 'undefined') {
        recognizer.current.onend = null
        recognizer.current.stop()
        return
      }

      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalResult += event.results[i][0].transcript
        } else {
          interimResult += event.results[i][0].transcript
        }
      }

      if (finalResult.length > 0 && interimResult.length === 0) {
        setResult(finalResult)
      } else if (finalResult.length === 0 && interimResult.length > 0) {
        setResult(interimResult)
      } else {
        setResult('')
      }
    }

    if (isRecognizing) {
      recognizer.current.start()
    }

    return () => {
      recognizer.current.abort()
      recognizer.current = null
    }
  }, [])

  useEffect(() => {
    if (!recognizer.current) {
      return
    }

    if (isRecognizing) {
      recognizer.current.continuous = continuous
      recognizer.current.start()
    } else {
      recognizer.current.stop()
    }
  }, [isRecognizing, continuous])

  const listen = (onOff) => setIsRecognizing(onOff)

  return {
    result,
    listen,
  }
}
